<template>
    <ul class="nav nav-tabs nav-tabs-bottom">
        <li class="nav-item dropdown" v-if="dropdownTitle">
            <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{ dropdownTitle }}</a>
            <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end">
                <slot name="dropdown"></slot>
            </div>
        </li>
        <li class="nav-item" v-for="tab in tabs" @click="activeTabKey = tab[tabKey]">
            <a  
                :href="`#tab-${tab[tabKey]}`"
                :class="{
                    'active': tab[tabKey] === activeTabKey,
                    'nav-link': true
                }"
            >
                {{ tab[tabName] }}
            </a>
        </li>
    </ul>
    <div class="tab-content">
        <div    
            v-for="tab in tabs"
            :id="`#tab-${tab[tabKey]}`"
            :class="{
                'tab-pane': true,
                'fade': true,
                'show': tab[tabKey] === activeTabKey,
                'active': tab[tabKey] === activeTabKey
            }">
            <slot :data="tab" :selectedTab="activeTabKey"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HorizontalTab',
    props: {
        tabs: {
            type: Array,
            required: true
        },
        tabKey: {
            type: String,
            required: true
        },
        tabName: {
            type: String,
            required: true
        },
        dropdownTitle: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            activeTabKey: this.tabs?.[0]?.[this.tabKey] ?? null
        }
    }
}
</script>
<style scoped>
.dropdown-menu {
    max-height: 300px;
    overflow: auto;
}
.nav-tabs {
    margin-bottom: 0px;
}
</style>